import React, { useContext } from "react";
import { Box, Button, Flex, HStack, VStack } from "@reverb-ui/react";
import { UsersTab } from "@/features/first-access/presentation/containers/company-users";
import { CompanyWizardContext } from "@/features/first-access/presentation/context-api/company-wizard-provider";
import { useHistory } from "react-router";
export var CompanyUsersForm = function (_a) {
    var hasNextStep = _a.hasNextStep, hasPreviousStep = _a.hasPreviousStep, goToNextStep = _a.goToNextStep, goToPrevStep = _a.goToPrevStep, locationId = _a.locationId;
    var createdCompanyId = useContext(CompanyWizardContext).createdCompanyId;
    var history = useHistory();
    return (React.createElement(Box, { w: "full" },
        React.createElement("form", null,
            React.createElement(VStack, { spacing: 8 },
                React.createElement(UsersTab, { rockId: createdCompanyId, locationId: locationId })),
            React.createElement(Flex, { justifyContent: "space-between", pt: 8, pb: 3 },
                React.createElement(Box, null, hasPreviousStep && (React.createElement(Button, { colorScheme: "blue", onClick: goToPrevStep }, "Previous"))),
                React.createElement(HStack, { spacing: 3 },
                    React.createElement(Button, { variant: "outline", onClick: function () { return history.push("/first-access/registration-done"); } }, "Done"))))));
};
